
import { firestore } from 'firebase/app';

export class OfferData {

	title: string;
	description: string;
	date: firestore.Timestamp | Date;
	expiration: firestore.Timestamp | Date;
	file?: string;
}

export class Offer extends OfferData {

	id: string;
}